export default "__VITE_ASSET__9b833769__"